import { toLogin } from "../../App/routes";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { SessionContext } from "../../App/useSession";

const Logout = () => {
  const { logout } = useContext(SessionContext);

  return (
    <Link to={toLogin} className="nav-link" onClick={logout} replace>
      Wyloguj
    </Link>
  );
};

export default Logout;
